export default __webpack_public_path__ + "static/main-store-manager-7ef14bfe8b57a346cc1092c96e8f4763.png";